import { css } from '@emotion/react';
import styled from '@emotion/styled';

import ProductItemList from './helpers/ProductItemList';
import pathToContent from './helpers/path_to_content';
import retrieveImage from './helpers/retrieveImage';
import { truncateText } from '../../../../helpers/text_truncate_helper';
import IconChevronRight from '../../../ComponentLibrary/icons/icon-chevron-right';
import RichText from '../../../OC/PageBuilder/RichText';
import { H4 } from '../../../OC/oc-h';
import { connectLocation } from '../../../location/LocationConnectors';

const TextContainer = styled.div`
  align-self: start;
  flex-direction: column;
  margin-left: 16px;
  width: 100%;
`;
const FleetwoodItemHeaderLink = styled.a`
  text-decoration: none;
`;
const FleetwoodItemHeader = styled(H4)`
  &&& {
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
  }
`;
const ViewProductLink = styled.a`
  color: black;
  cursor: pointer;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  text-decoration: none;
`;
const ItemImage = styled.img`
  flex-shrink: 0; // flex-shrink here will prevent the images from shrinking below the set width
  height: 270px;
  object-fit: cover;
  width: 480px;

  @media (max-width: 767px) {
    height: unset;
    margin-bottom: 16px;
    width: 100%;
  }
`;

const ProductListItem = connectLocation(({ ...product }) => {
  const listItemImage = retrieveImage(product);
  const generalContent = product.metadata?.settings?.general;
  const properName = generalContent?.proper_name;
  const itemText = generalContent?.long_description || generalContent?.short_description;
  const itemUrl = pathToContent(product);

  return (
    <>
      {listItemImage && <ItemImage src={listItemImage?.file} alt={properName} />}
      <TextContainer>
        <FleetwoodItemHeaderLink href={itemUrl}>
          <FleetwoodItemHeader>{properName}</FleetwoodItemHeader>
        </FleetwoodItemHeaderLink>
        <RichText content={truncateText(itemText, 320)} />
        <ViewProductLink href={itemUrl}>
          <span>View Product</span>
          <IconChevronRight
            height="14px"
            width="8px"
            css={css`
              margin-left: 16px;
            `}
          />
        </ViewProductLink>
      </TextContainer>
    </>
  );
});

export default ProductItemList({
  common: {
    type: 'Product::Fleetwood',
  },
  search: {
    name: 'Fleetwood Products',
    preview: result => ({
      heading: result.metadata?.settings?.general?.proper_name || result.name,
    }),
  },
  list: {
    availableIn: ['www.fleetwoodusa.com'],
    name: 'Products - Fleetwood',
    attributeSet: {
      name: 'Product Attributes',
      path: '',
    },
    dataset: 'products_fleetwood',
    view: ProductListItem,
    enableSearch: true,
  },
});
